import { Splide } from '@splidejs/splide';

const defaultOptions = {
    type: 'loop',
    perPage: 1,
    classes: {
        pagination: 'splide__pagination',
        page: 'splide__pagination__page'
    }
};

export default function ({ onlyMobile = false, options = {} }) {
    return {
        onlyMobile,

        options: {
            ...defaultOptions,
            ...options,
            classes: {
                ...defaultOptions.classes,
                ...options.classes
            }
        },

        slider: null,

        init() {
            this.setupWatchers();

            if (!this.onlyMobile || this.isMobile()) {
                this.mount();
            }
        },

        setupWatchers() {
            this.$watch('isMobile()', (isMobile) => {
                if (!this.onlyMobile) return;

                if (isMobile) {
                    this.mount();
                } else {
                    this.destroy();
                }
            });

            this.$watch('$store.mq.minWidth', () => {
                if (!this.slider) return;

                this.slider.go(0);
                this.setActiveNavItems(0);
            });
        },

        isMobile() {
            return this.$store.mq.isMobile();
        },

        mount() {
            if (this.slider) return;
            if (this.onlyMobile && !this.isMobile()) return;

            const element = this.$el.querySelector('.splide');

            if (!element) return;

            this.slider = new Splide(element, this.options);

            this.setupSliderEvents();
            this.slider.mount();
            this.setActiveNavItems(0);
        },

        destroy() {
            if (!this.slider) return;

            this.slider.destroy(true);
            this.slider = null;
        },

        setupSliderEvents() {
            this.slider.on('moved', (index) => {
                this.setActiveNavItems(index);
            });

            // Zostawić tylko wtedy, gdy reset do początku
            // przy każdym resize jest wymaganiem biznesowym.
            this.slider.on('resized', () => {
                this.setActiveNavItems(this.slider.index);
            });
        },

        setActiveNavItems(index) {
            const activeClass = 'show';
            const navItems = Array.from(
                this.$el.querySelectorAll('li[role="presentation"]')
            );

            if (!navItems.length) return;

            const activeItems = new Set(
                this.getClosestElements(navItems, index)
            );

            navItems.forEach((item) => {
                item.classList.toggle(activeClass, activeItems.has(item));
            });
        },

        getClosestElements(target = [], index = 0, limit = 5) {
            if (target.length <= limit) {
                return target;
            }

            if (index <= 1) {
                return target.slice(0, limit);
            }

            const result = target.slice(index - 2, index + 3);

            if (result.length < limit) {
                return result.concat(target.slice(0, limit - result.length));
            }

            return result;
        }
    };
}
